<template>
	<page-container :page="page">
		<heading-image
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
			:title="page.title || page.header"
		>
			<template #scrollDown>
				<scroll-down
					v-if="route.name.startsWith('index')"
					:content="defaults[locale].homepage.scrollDownText"
				/>
			</template>
		</heading-image>

		<main-heading
			:title="page.title || page.header"
			:content="page.introductionContent"
			:button="{ text: page.introductionButton, link: page.introductionButtonLink }"
			:graphic="{
				image: page.introductionGraphic,
				imageWebp: page.introductionGraphicWebp,
				alt: page.introductionGraphicAlt,
			}"
		/>

		<div class="homepage">
			<main-content :class="page && page.headingImage ? '' : 'no-slider'" :content="page.content" />
		</div>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
		/>

		<image-grid
			v-if="page && page.gallery"
			:header="page.gallery.header"
			:content="page.gallery.content"
			:items="page.gallery"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();
const route = useRoute();

await fetchPage();
await fetchDefaults();
useIntersectionObserver();
</script>

<style lang="scss" scoped>
.hero-content {
	position: absolute;
	top: 45%;
	left: 0;
	right: 0;
	z-index: 3;
	text-align: center;
	padding: 0 20px;
	color: #fff;
	animation: fade-from-bottom 1.4s ease;

	span {
		color: #fff;
		font-weight: 400;
		font-size: 72px;
		letter-spacing: 1px;
		width: 100%;
		font-family: var(--heading-font-family);
		display: inline-block;
		margin: 0 0 10px;
	}

	.hero-subtitle {
		font-size: 24px;
		font-weight: 300;
		font-family: var(--body-font-family);
	}
}

.row-header {
	max-width: 630px;
	margin: 0 auto 60px;

	h2 {
		width: 100%;
		text-align: center;
	}

	p {
		margin: 0;
	}
}

.button-row {
	margin: 60px auto 0;
}

@media (max-width: 880px) {
	.hero-content {
		.hero-title {
			font-size: 62px;
		}

		.hero-subtitle {
			font-size: 24px;
		}
	}
}

@media (max-width: 680px) {
	.row-header {
		margin: 0 auto 40px;
	}

	.hero-content {
		.hero-title {
			font-size: 54px;
		}

		.hero-subtitle {
			font-size: 22px;
		}
	}
}

@media (max-width: 520px) {
	.hero-content {
		.hero-title {
			font-size: 46px;
		}

		.hero-subtitle {
			font-size: 20px;
		}
	}
}
</style>
